import { storageKey } from "../constants/constants";
import { SessionStorageService } from "./SessionStorage";

// utils/auth.ts
export const isLoggedIn = (): boolean => {
  return !!SessionStorageService.getItem(storageKey.token);  // Return true if token exists, false otherwise
};
